import axios from '@/libs/api.request'

export const getPageList = (data) => {
  return axios.request({
    url: '/file/queryPageList',
    params: data,
    method: 'get'
  })
}

export const delById = (data) => {
  return axios.request({
    url: '/file/delById',
    data: data,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/oss.js